module.exports = __webpack_public_path__ + "files/ea37ab1fb41eb2f7759312f7786e994a.png";